import * as types from './types';
import categories from '../queries/categories';
import user from '../queries/user';
import posts from '../queries/posts';
import relatedClasses from '../queries/relatedClasses';
import projectIntroduction from '../queries/projectIntroduction';
import projectProgress from '../queries/projectProgress';
import scripts from '../queries/scripts';

const findCategory = (categories, categoryId) => {
  if (!categories) {
    return null;
  }

  for (let i = 0; i < categories.length; i += 1) {
    const category = categories[i];

    if (Number(category.id) === Number(categoryId)) {
      return category;
    }

    const foundCategory = findCategory(category.categories, categoryId);

    if (foundCategory) {
      return foundCategory;
    }
  }

  return null;
};

export const fetchProgress = ({ commit, rootState, state }) => {
  const { id: projectId } = rootState.app.project;
  const { id: userId } = state.userInfo;

  projectProgress.fetch(userId, projectId)
    .then((response) => {
      const { progress } = response.data.progress;
      commit(types.SET_COURSE_PROGRESS, progress);
    });
};

export const fetchCategories = ({ commit, dispatch, rootState, state }, categoryId) => {
  const { id: projectId } = rootState.app.project;
  const { categoriesList } = state;

  const category = findCategory(categoriesList, categoryId);
  if (categoryId !== null && category && category.categories.length) {
    return;
  }

  categories.fetchAll(categoryId, projectId)
    .then((response) => {
      const { available_categories_by_parent: categories } = response.data;

      commit(types.SET_CATEGORIES_LIST, { categories, categoryId });
      dispatch('fetchUserRelatedCategoryDetails', categories);
    });
};

export const fetchUserRelatedCategoryDetails = ({ commit }, categoryList) => {
  const categoryIds = categoryList.map(category => category.id);

  categories.userRelatedDetails(categoryIds)
    .then((response) => {
      const categoriesDetails = response.data.categories_by_ids;

      commit(types.SET_CATEGORIES_STATUS, categoriesDetails);
    });
};

export const fetchCategoryPostDetails = ({ commit }, category) => {
  if (!category.published_posts) {
    return;
  }

  posts.fetchFromCategory(category)
    .then((response) => {
      const posts = response.data.posts_by_ids;

      commit(types.SET_POSTS_DETAILS, posts);
    });
};

export const fetchUserInfo = ({ dispatch }) =>
  user.getInfo()
    .then((response) => {
      const userInfo = response.data.current_user_info;
      return dispatch('setUserInfo', userInfo);
    });

export const setUserInfo = ({ commit }, userInfo) => {
  commit(types.SET_USER_INFO, userInfo);
};

export const resetUserInfo = ({ commit }) => commit(types.RESET_USER_INFO);

export const fetchRelatedClasses = ({ commit }) => {
  relatedClasses.fetch()
    .then((response) => {
      const { data } = response;

      commit(types.SET_RELATED_POSTS, data.related_classes);
    });
};

export const fetchCurrentPost = ({ commit }) => {
  posts.fetchCurrent()
    .then((response) => {
      const { data } = response;

      commit(types.SET_CURRENT_POST, data.current_post);
    });
};

export const fetchIntroduction = ({ commit }) =>
  projectIntroduction.fetch()
    .then((response) => {
      const projIntro = response.data.current_user_info.group.project.project_introduction;
      return commit(types.SET_INTRODUCTION, projIntro);
    });

export const toggleCategory = ({ commit, dispatch }, categoryId) => {
  commit(types.TOGGLE_CATEGORY, categoryId);

  return dispatch('fetchCategories', categoryId);
};

export const hideCategory = ({ commit, dispatch }, categoryId) => {
  commit(types.HIDE_CATEGORY, categoryId);
};

export const closeCategories = ({ commit }) => commit(types.CLOSE_CATEGORIES);

export const fetchScripts = ({ rootState }) => scripts.getScripts(rootState.app.project.id)
  .then(response => response.data.current_user_info.group.project.scripts);



// WEBPACK FOOTER //
// ./src/screens/Index/store/actions.js